import React from 'react';
import styles from './About.module.css';

const About: React.FC = () => {
  return (
    <div className={styles.aboutContainer}>
      <div className={styles.aboutContent}>        
        <div className={styles.aboutSection}>
          <h3>Overview</h3>
          <p>
            Valolens.com is a comprehensive Valorant VOD analysis service.
          </p>
        </div>

        <div className={styles.aboutSection}>
          <h3>Connect With Us</h3>
          <p>
            Join our community and stay updated with the latest features and announcements.
          </p>
          <div className={styles.socialButtons}>
            <a href="https://discord.gg/EQm6ZNMPh5" target="_blank" className={styles.discordButton} rel="noreferrer">
              <img src="/discord-icon.png" height={15} alt="Discord icon" />
              <span className={styles.discordLabel}>Discord</span>
            </a>
            <a href="https://x.com/valolens" target="_blank" className={styles.twitterButton} rel="noreferrer">
              <img src="/x-icon.png" height={15} alt="X icon" />
              <span className={styles.twitterLabel}>X/Twitter</span>
            </a>
          </div>
        </div>

        <div className={styles.aboutSection}>
          <h3>Payments & Cancellation</h3>
          <p>
            Payment is required upfront at the start of each monthly period.
          </p>
          <p>
            We use LemonSqueezy, a secure and globally recognized payment service, to process all payments for our services. If you decide to cancel your subscription, it will remain active until the end of the current monthly period.
          </p>
          <p>
            You can manage your subscription from the <a href="/account" className={styles.link}>Account</a> page.
          </p>
        </div>

        <div className={styles.aboutSection}>
          <h3>Company Information</h3>
          <p>
            The valolens.com service is a product of Juhakiili Oy, a company registered and operating from Finland.
          </p>
          <p>
            Juhakiili Oy<br />
            Välilausteentie 9, 21350 Ilmarinen, Finland<br />
            FIFPRO.2398119-8
          </p>
        </div>

        <div className={styles.aboutSection}>
          <h3>Contact Information</h3>
          <p>
            For any inquiries, please check our <a href="/support" className={styles.link}>support</a> page. Our goal is to provide a prompt and satisfactory resolution to all queries.
          </p>
        </div>

        <div className={styles.aboutSection}>
          <h3>Terms & Conditions</h3>
          <p>
            Please refer to our <a href="/terms" className={styles.link}>Terms & Conditions</a>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default About; 